import { render, staticRenderFns } from "./SentOrders.vue?vue&type=template&id=2abac503"
import script from "./SentOrders.vue?vue&type=script&lang=js"
export * from "./SentOrders.vue?vue&type=script&lang=js"
import style0 from "./SentOrders.vue?vue&type=style&index=0&id=2abac503&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports